/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/AppointmentOverlay/Content/Form/Content/TreatmentSelect/Content/Trigger/Empty",
  disabled
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<div
  data-testid="Empty.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-4PwO0': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--c-2-4PwO0': disabled ? "not-allowed" : "pointer"}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 display="block"
 overflowX="hidden"
 textOverflow="ellipsis"
 whiteSpace="nowrap"
 weight="medium"
 text="Select treatment"
/>
<fromFlow.When is={!disabled}>
<div
  data-testid="Empty.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaIconArrowDown
  viewPath={`${viewPath}/TysiaIconArrowDown`}
 fill2={dtColorsNeutral700}
 width={12}
 height={12}
/>
</div>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}